"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyIntelligenceService = void 0;
class AirwebTicketLegacyIntelligenceService {
    constructor(client) {
        this.client = client;
    }
    async sendGeolocation(userToken, geolocation, options = {}) {
        const response = (await this.client.http
            .post('Intelligence/sendGeolocation.json', Object.assign(Object.assign({}, geolocation), { userToken }), options)
            .catch(this.handleError));
        return response.data;
    }
    handleError(error) {
        throw error;
    }
}
exports.AirwebTicketLegacyIntelligenceService = AirwebTicketLegacyIntelligenceService;
//# sourceMappingURL=intelligence.service.js.map